<template>
  <div class="uk-animation-fade">
    <!-- cover image: -->
    <div class="image-container">
      <div class="wrapper">
        <img src="../assets/jpg/skyline.jpg" alt />
        <div class="text uk-visible@m">
          <span>
            "Snel, en vakkundig met oog voor detail.
            <br />Dit zijn de kernwaarden waar wij trots op zijn"
          </span>
        </div>
      </div>
    </div>

    <!-- cards: -->
    <div class="uk-container card-container uk-padding-large">
      <div class="uk-child-width-expand@m uk-grid-match uk-text-center" uk-grid>
        <div>
          <div class="uk-card uk-card-default uk-card-body">
            <h3 class="uk-card-title">Waarom DNZ PROJECTS?</h3>
            <p class="uk-text-justify">
              DNZ Projects is al vanaf 2016 werkzaam in de particuliere en
              zakelijke sector voor zowel nieuwbouw
              als renovatie in de installatiebranche.
              Met onze kennis en aanpak zorgen we voor uw
              technische installatie. DNZ Projects installeert
              dagelijks betrouwbare installaties voor zijn klanten.
              Wij zijn een betrouwbare partner. Vakmanschap, professionaliteit en
              betrouwbaarheid zijn de waarden waar ons
              bedrijf voor staat.
              Wij beschikken over de nodige certificaten voor
              het werk dat uitgevoerd moet worden. Dit geeft u extra
              zekerheid over de kwaliteit van het werk. Kies daarom voor DNZ Projects.
            </p>

            <span
              class="uk-text-center link uk-text-middle"
              uk-toggle="target: #message-modal"
            >maak contact met DNZ PROJECTS</span>
            <span class="icon uk-margin-top" uk-icon="arrow-right"></span>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default uk-card-body">
            <h3 class="uk-card-title">onze pijlers:</h3>

            <ul class="uk-list uk-text-left uk-margin-left">
              <li>
                <span class="material-icons icon uk-text-middle">verified_user</span>
                <span class="uk-text-middle">Betrouwbare partner</span>
              </li>
              <li>
                <span class="material-icons icon uk-text-middle">mood</span>
                <span class="uk-text-middle">Klantgericht</span>
              </li>
              <li>
                <span class="material-icons icon uk-text-middle">filter_vintage</span>
                <span class="uk-text-middle">Oog voor duurzaamheid</span>
              </li>
              <li>
                <span class="material-icons icon uk-text-middle">build</span>
                <span class="uk-text-middle">Vakmanschap</span>
              </li>
              <li>
                <span class="material-icons icon uk-text-middle">school</span>
                <span class="uk-text-middle">Professioneel</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped >
@import "../assets/vars.less";

.image-container {
  display: flex;
  justify-content: center;
  .wrapper {
    position: relative;
  }
  img {
    width: 100%;
    max-width: 100rem;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .text {
    background: rgba(104, 104, 104, 0.486);
    padding: 1rem;
    position: absolute;
    top: 3rem;
    left: 3rem;
    font-family: "Space Mono";
    font-size: 1.5rem;
    text-transform: uppercase;
    color: rgb(255, 255, 255);
    font-weight: 400;
  }
}

.card-container {
  li {
    font-size: 1.2rem;
    font-family: "Space Mono";
    text-transform: uppercase;
    color: gray;
  }
  .icon {
    color: @primary-color;
    padding: 0 0.8rem;
  }
  .link {
    color: @primary-color;
    font-family: "Space Mono";
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
      text-decoration: none;
      color: @primary-color-hover;
      cursor: default;
    }
  }
  @media screen and (max-width: 900px) {
    li {
      font-size: 1rem;
      font-family: "Space Mono";
      text-transform: uppercase;
    }

    .link {
      font-size: 0.8rem;
    }
  }
}
</style>
